<template>
  <draggable
      class=""
      tag="div"
      :list="items"
      :group="{ name: 'g2' }"
      item-key="name"
      @end="changeItem"
  >
    <template #item="{ element }">
      <div class="bg-white overflow-hidden rounded-lg bg-white mb-4 shadow">
        <div class="flex justify-start gap-3 px-5 py-5" :data-debug-order="element.order" :data-debug-id="element.id">
          <span class="text-gray-900 text-base font-semibold leading-normal">{{ element.title }}</span>
          <button v-if="!isPilot && ((element.only_network_id === element.thisNetworkId) || isAdmin)" @click="openQuestionSectionModal(element.id)" type="button" class="network-button-color hover:text-gray-900">
            <PencilSquareIcon class="ml-1 -mr-0.5 h-5 w-5" aria-hidden="true" />
          </button>
          <button v-if="!isPilot" @click="openQuestionModal(questionSetId, element.id)" type="button" class="network-button-color hover:text-gray-900 flex justify-start">
            <PlusCircleIcon class="flex-none -ml-1 -mr-0.5 h-5 w-5 mr-1" aria-hidden="true" />
            Add question
          </button>
        </div>
        <question-nested-draggable-question :items="element.questions" @save-change-question="changeItem" class="px-5 py-2"/>
      </div>
    </template>
  </draggable>
</template>

<script>
import draggable from "vuedraggable";
import QuestionNestedDraggableQuestion from "./QuestionNestedDraggableQuestionComponent.vue";
import {PlusCircleIcon, PencilSquareIcon} from "@heroicons/vue/20/solid";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import QuestionCreateEditFormComponent from "../Question/QuestionCreateEditFormComponent.vue";
import QuestionSectionCreateEditFormComponent from "../QuestionSection/QuestionSectionCreateEditFormComponent.vue";

export default {
  name: "QuestionNestedDraggableItemComponent",

  props: {
    items: {
      required: true,
      type: Array
    },
    questionSetId: {
      required: true,
      type: Number,
    }
  },
  components: {
    draggable,
    QuestionNestedDraggableQuestion,
    PlusCircleIcon,
    PencilSquareIcon,
  },
  computed: {
    isAdmin() {
      return this.$store.state.userIsAccountLevelAdmin;
    },
    isPilot() {
      return this.$store.state.onlyPilotNetwork;
    },
  },
  methods: {
    changeItem() {
      this.$emit('save-change-item');
    },
    openQuestionModal(questionSetId, questionSectionId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionCreateEditFormComponent,
            attrs: {
              questionSetId: questionSetId,
              questionSectionId: questionSectionId,
              onReloadIndex() {
                self.$emit('save-change-item');
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
    openQuestionSectionModal(questionSectionId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionSectionCreateEditFormComponent,
            attrs: {
              questionSectionId: questionSectionId,
              onReloadIndex() {
                self.$emit('save-change-item');
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
};
</script>